<template lang="html">
    <div class="">
        <div class="top-bar">
            <span class="refresh-icon" @click="goBackToFBPpage">
                <i class="left"></i>
            </span>
            <span class="heading_new">Claim FBP</span>
            <span class="spacer" />
            <span @click="refresh" class="refresh-icon">
                <img src="@/assets/path-copy.svg" />
            </span>
        </div>

        <div class="innercontainer">
            <div class="singleColumnGrid">
                <tl-select label="FBP Component" :options="monthsData" v-model="formData.fbpComponent" @change="(val)=>formData.fbpComponent = val"
                    name="month" :classname="errors.has('month')" v-validate="'required'" :errormsg="errors.first('month')"></tl-select>
            </div>

            <div class="threeColumnGrid margin-top-10">
                <txt label="Bill Amount" type="text" v-model='formData.billAmount' name="Bill Amount" v-validate="'required'" :classname="errors.has('Bill Amount')"
                    :errormsg="errors.first('Bill Amount')" />

                <txt label="Claim Amount" type="text" v-model='formData.claimAmount' name="Claim Amount" v-validate="'required'" :classname="errors.has('Claim Amount')"
                    :errormsg="errors.first('Claim Amount')" />

                <label class="eligibility-text  margin-top-28">
                    Eligibility: 45000
                </label>
            </div>

            <div class="threeColumnGrid margin-top-30">

                <div>
                    <span class="input-label">Bill Date</span>
                    <date-picker class="" @datevalue="(val)=>formData.billDate=val" :value="formData.effectiveDate" name="effectiveDate" :classname="errors.has('effectiveDate')"
                        v-validate="'required'" :errormsg="errors.first('effectiveDate')" />
                </div>

                <txt label="Bill Number" type="text" v-model='formData.billNumber' name="Bill Number" v-validate="'required'" :classname="errors.has('Bill Number')"
                    :errormsg="errors.first('Bill Number')" />
            </div>

            <div class=" margin-top-30">
                <upload></upload>
            </div>

            <div class="threeColumnGrid margin-top-30">
                <tl-select label="Status" labelText="status" :options="statusData" v-model="formData.status" @change="(val)=>formData.status = val"
                    name="status" :classname="errors.has('status')" v-validate="'required'" :errormsg="errors.first('status')"></tl-select>
            </div>


            <div class="singleColumnGrid margin-top-20">
                <txt class="remarks" label="Remarks" name="remarks" type="textarea" v-model="formData.remarks" />
            </div>

        </div>

        <bottom-action-container >
            <template slot="end">
                <btn-grp>
                    <btn text="Cancel" type="secondary" @click="cancel" />
                    <btn text="Save" type="primary" @click="save" />
                </btn-grp>
            </template>
        </bottom-action-container>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";

    export default {
        name: "newFbpClaim",
        computed: {
            ...mapState({}),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            })
        },
        data() {
            return {
                monthsData: [
                    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',
                ],

                statusData: [
                    'Submitted', 'Approved', 'Rejected'
                ],

                formData: {
                    fbpComponent: '',
                    billAmount: '₹',
                    claimAmount: '₹',
                    billDate: '',
                    billNumber: '',
                    status: '',
                    remarks: ''
                },
            };
        },
        mounted() { },

        methods: {
            ...mapActions({}),

            refresh() { },

            cancel() {

            },

            save() {

            },

            goBackToFBPpage() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpClaims`
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .top-bar {
        padding: 20px;
        background-color: #34c0be;
        display: flex;
    }

    .heading_new {
        font-family: Montserrat;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        width: auto !important;
    }

    .left {
        border: solid white;
        border-width: 0 2px 2px 0;
        padding: 5px;
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        margin-top: 9px;
        margin-right: 20px;
    }

    .refresh-icon {
        cursor: pointer;
    }

    .innercontainer {
        padding: 30px 13px;
        margin-bottom: 110px;
    }

    .threeColumnGrid {
        grid-template-columns: 16% 16% auto;
    }

    .margin-top-28 {
        margin-top: 28px;
    }

    .margin-top-30 {
        margin-top: 30px;
    }

    .margin-top-20 {
        margin-top: 20px;
    }

    .margin-top-10{
        margin-top: 10px;
    }

    .eligibility-text {
        opacity: 0.5;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        color: #000000;
    }

    .remarks {
        width: 300px;
        height: 101px;
        height: 101px;
    }

    .tl-select-dropdown {
        margin-bottom: 0px;
    }
</style>